module.exports = __webpack_public_path__ + "img/line-desktop.6ef74ae6.svg";